import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




// UPDATE A FORM CATEGORY
const submit = (payload) => client.put('forms/categories', payload);
export const useUpdateFormCategory = (id,payload) => useMutation(['updateFormCategory',id],() => submit(payload))